import { IDocumentImageSource } from "../IDocumentImageSource";
import { ImageSourceKinds } from "../ImageSourceKinds";
import { AbstractRectangleItem } from "./AbstractRectangleItem";
import { TypeKeys } from "./TypeKeys";

export class StampItem extends AbstractRectangleItem {
  constructor() {
    super(TypeKeys.StampItem);
  }
  
  public name: string = null;
  public imageSource: IDocumentImageSource = null;
  public stampUserCode: string = null;
  public isStamped: boolean = false;

  protected createCloneInstance(): StampItem {
    return new StampItem();
  }

  protected applyMembers(clone: StampItem): void {
    super.applyMembers(clone);
    clone.name = this.cloneValue(this.name);
    clone.imageSource = this.cloneValue(this.imageSource);
    clone.stampUserCode = this.cloneValue(this.stampUserCode);
    clone.isStamped = this.cloneValue(this.isStamped);
  }

  public clearStamp(): void {
    if (this.imageSource) {
      this.imageSource.imageGuid = null;
      this.imageSource.imageSourceKind = ImageSourceKinds.None;
    }
    this.stampUserCode = null;
    this.isStamped = false;
  }

  public get hasImage(): boolean {
    return !!this.imageSource && !!this.imageSource.imageGuid && (this.imageSource.imageSourceKind !== ImageSourceKinds.None);
  }
}
